module.exports = __webpack_public_path__ + "img/IT0003256932819.06171ea5.png";